// extracted by mini-css-extract-plugin
export default {"text":"SingleAssetPositionLayer_text__Hm7MR"};